<template>
  <a-layout-content class="panel">
    <header class="panel__header">
      <div
        class="panel__title"
        v-if="title"
      >{{ title }}</div>
      <div class="panel__title__row">
        <slot name="title_row" />
      </div>
      <div class="panel__search">
        <slot name="search" />
      </div>
    </header>
    <a-layout-content class="panel__content">
      <header class="panel__content__header">
        <slot name="header" />
      </header>
      <main class="panel__content__main">
        <slot name="content" />
      </main>
      <footer class="panel__content__footer">
        <slot name="footer" />
      </footer>
      <slot />
    </a-layout-content>
  </a-layout-content>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="less" scoped>
.panel {
  padding: 24px 32px 48px;
  
  &__title {
    color: var(--text-color);
    font-weight: 500;
  }

  &__search {
    padding-top: 24px;
    
    &:empty {
      display: none;
    }

    ::v-deep {
      .antmain-form-inline .antmain-form-item {
        display: flex;
        width: 100%;

        & > .antmain-form-item-control-wrapper {
          flex-grow: 1;
        }

        .antmain-btn:not(:last-child) {
          margin-right: 8px;
        }
      }
    }
  }

  &__content {
    padding: 16px 24px;
    margin-top: 24px;
    background-color: var(--module-bg);

    &__header, &__footer {
      &:empty {
        display: none;
      }
    }

    &__header {
      margin-bottom: 16px;
    }

    &__footer {
      margin-top: 16px;
    }
  }
}
</style>
